// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__paGLu","alertIcon":"ConfirmModal_alertIcon__3EXJH"};